export const Content1DataSource = {
  wrapper: { className: 'home-page-wrapper eLearn-content1-wrapper' },
  page: { className: 'home-page eLearn-content1' },
  OverPack: { playScale: 0.1 },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        className: 'title-h1',
        children: 'product.eLearn.platform'
      },
      {
        name: 'sub-title',
        className: 'sub-title',
        children: 'ELEARN VEHICLE DATA MODELLING AND ANALYSIS PLATFORM'
        // children: 'eLearn vehicle data modelling and analysis platform'
      },
      {
        name: 'content',
        className: 'content',
        children: 'product.eLearn.introduce'
      },
      {
        name: 'video',
        className: 'eLearn-content1-block-video-button',
        title: 'product.eLearn.videoIntroduction',
        children: '',
      },
    ],
  },
};
export const Content2DataSource = {
  wrapper: { className: 'home-page-wrapper eLearn-content2-wrapper' },
  page: { className: 'home-page eLearn-content2' },
  OverPack: { playScale: 0.1 },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        className: 'title-h1',
        children: 'product.eLearn.solution'
      },
      {
        name: 'sub-title',
        className: 'sub-title',
        children: 'SOLUTION'
      },
    ],
  },
};

export const Content3DataSource = {
  wrapper: { className: 'home-page-wrapper eLearn-content3-wrapper' },
  page: { className: 'home-page eLearn-content3' },
  OverPack: { playScale: 0.3, className: '' },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      { name: 'title', className: 'title-h1', children: 'product.eLearn.applicationScenario' },
      { name: 'sub-title', className: 'sub-title', children: 'APPLICATION SCENARIO' }
    ],
  },
  childWrapper: {
    className: 'eLearn-content3-block-wrapper',
    children: [
      {
        name: 'block0',
        className: 'eLearn-content3-block',
        active: true,
        children: {
          className: 'eLearn-content3-block-item',
          img: 'eLearn-02.png',
          title: 'product.eLearn.applicationScenarioTitle01',
          children: [
            {
              name: 'content',
              className: 'eLearn-content3-block-content',
              children: 'product.eLearn.applicationScenarioContent01',
            }
          ],
        },
      },
      {
        name: 'block1',
        className: 'eLearn-content3-block',
        active: true,
        children: {
          className: 'eLearn-content3-block-item',
          img: 'eLearn-03.png',
          title: 'product.eLearn.applicationScenarioTitle02',
          children: [
            {
              name: 'content',
              className: 'eLearn-content3-block-content',
              children: 'product.eLearn.applicationScenarioContent02',
            },
          ],
        },
      },
      {
        name: 'block2',
        className: 'eLearn-content3-block',
        active: true,
        children: {
          className: 'eLearn-content3-block-item',
          img: 'eLearn-04.png',
          title: 'product.eLearn.applicationScenarioTitle03',
          children: [
            {
              name: 'content',
              className: 'eLearn-content3-block-content',
              children: 'product.eLearn.applicationScenarioContent03',
            }
          ],
        },
      },
      {
        name: 'block3',
        className: 'eLearn-content3-block',
        active: true,
        children: {
          className: 'eLearn-content3-block-item',
          img: 'eLearn-05.png',
          title: 'product.eLearn.applicationScenarioTitle04',
          children: [
            {
              name: 'content',
              className: 'eLearn-content3-block-content',
              children: 'product.eLearn.applicationScenarioContent04',
            }
          ],
        },
      },
      {
        name: 'block4',
        className: 'eLearn-content3-block',
        active: true,
        children: {
          className: 'eLearn-content3-block-item',
          img: 'eLearn-06.png',
          title: 'product.eLearn.applicationScenarioTitle05',
          children: [
            {
              name: 'content',
              className: 'eLearn-content3-block-content',
              children: 'product.eLearn.applicationScenarioContent05',
            }
          ],
        },
      },
    ],
  },
};
